<template>
  <div class="h100vh-116">
    <div class="h100vh-116 h-scroll">
      <ejs-grid ref='grid' height='calc(100% - 120px)' :dataSource="data" :allowResizing='true' :rowDeselected='getChooseCount' :rowSelected='getChooseCount'>
        <e-columns>
          <e-column type='checkbox' headerText='imsi' width='30' textAlign='Center'></e-column>
          <e-column field='name' headerText='环境名称' width='100' textAlign='Center'></e-column>
          <e-column field='content.dpIp' headerText='IP' width='100' textAlign='Center' :formatter='iPFormat'></e-column>
          <e-column field='content.dpPort' headerText='端口' width='100' textAlign='Center' :formatter='portFormat'></e-column>
          <e-column field='content.product' headerText='產品' width='100' textAlign='Center' :formatter='productFormat'></e-column>
          <e-column field='content.deploymentNorm' headerText='部署模式' width='150' textAlign='Center' :formatter='deploymentNormFormat'></e-column>
          <e-column field='createTime' headerText='创建时间' width='100' textAlign='Center' type='date' format='yyyy-MM-dd HH:mm:ss'></e-column>
          <!--<e-column field='operation' headerText='操作' textAlign='Center' width='5%'
                    clipMode='EllipsisWithTooltip' :template='cTemplate'></e-column>-->
        </e-columns>
      </ejs-grid>
    </div>
    <CustomDialog ref='addDPEnviromentPage' :element='dialog.element.eleAddDpEnviroment' :styles='dialog.styles' :messages='dialog.messages.addDpEnviroment'>
      <template v-slot:dialog-content>
        <AddDPEnviroment ref='addDPEnviromentDialog'></AddDPEnviroment>
      </template>
    </CustomDialog>
    <CustomDialog ref='oneKeyDeploymentPage' :element='dialog.element.eleDeployment' :styles='dialog.deployStyles' :messages='dialog.messages.addDeployment'>
      <template v-slot:dialog-content>
        <OneKeyDeployment ref='oneKeyDeploymentDialog'></OneKeyDeployment>
      </template>
    </CustomDialog>
    <CustomDialog ref='deployedInstancePage' :element='dialog.element.eleDeployedInstance' :styles='dialog.deployedInstanceStyles' :messages='dialog.messages.addDeployedInstance'>
      <template v-slot:dialog-content>
        <Table ref="deployedInstanceDialog" :qryParam="qryParam"></Table>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from '../../../common/CustomDialog';
import AddDPEnviroment from './dialog/AddDPEnviroment';
import DPEnviromentOperButton from './DPEnviromentOperButton';
import OneKeyDeployment from './dialog/OneKeyDeployment';
import Table from '../../serverManagement/Table';
import { EventBus } from '../../../../plugins/eventBus';


export default {
  name: 'DPEnviromentTable',
  components: {
    CustomDialog,
    AddDPEnviroment,
    OneKeyDeployment,
    Table
  },
  data() {
    return {
      data: {},
      qryParam: {
        environmentId: ''
      },
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 100
      },
      cTemplate() {
        return { template: DPEnviromentOperButton };
      },
      dialog: {
        styles: {
          width: '40%',
          height: '70%',
          visible: false,
          model: true
        },
        deployStyles: {
          width: '60%',
          height: '90%',
          visible: false,
          model: true
        },
        deployedInstanceStyles: {
          width: '70%',
          height: '90%',
          visible: false,
          model: true
        },
        element: {
          eleDeployment: {
            target: this.$refs.deployBtn,
            refName: 'eleDeployment',
            buttonGroup: [
              { click: this.closeOneKeyDeploymentPage, buttonModel: { content: this.$t('UE.ueCancell') } },
              { click: this.oneKeyDeployment, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }
            ],
            title: '一键部署',
            isClose: true
          },
          eleAddDpEnviroment: {
            target: this.$refs.grid,
            refName: 'eleAddDpEnviroment',
            buttonGroup: [
              { click: this.closeDPEnviromentPage, buttonModel: { content: this.$t('UE.ueCancell') } },
              { click: this.createEnvironment, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }
            ],
            title: '添加DP环境',
            isClose: true
          },
          eleDeployedInstance: {
            target: this.$refs.deployBtn,
            refName: 'eleDeployedInstance',
            buttonGroup: [
              { click: this.closeDeployedInstancePage, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }
            ],
            title: '部署状态',
            isClose: true
          }
        },
        messages: {
          addDpEnviroment: {
            title: '添加DP环境'
          },
          addDeployment: {
            title: '一键部署'
          },
          addDeployedInstance: {
            title: '部署状态'
          }
        }
      },
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0
      }
    };
  },
  methods: {
    closeOneKeyDeploymentPage() {
      this.$refs.oneKeyDeploymentPage.clear();
      this.$refs.oneKeyDeploymentPage.close();
    },
    closeCreateEnvironmentPage() {
      this.$refs.addDPEnviromentPage.clear();
      this.$refs.addDPEnviromentPage.close();
    },
    closeDeployedInstancePage() {
      this.$refs.deployedInstancePage.clear();
      this.$refs.deployedInstancePage.close();
    },
    createEnvironment() {
      const params = this.$refs.addDPEnviromentDialog.getData();
      this.$axios.post('/lte/ems/env/createEnvironment.html', params).then((response) => {
        this.closeCreateEnvironmentPage();
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            this.getGridData();
            EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
          } else {
            EventBus.$emit('toast', { type: 'warning', content: '添加失败' });
          }
        }
      });
    },
    iPFormat(grids, data) {
      const content = JSON.parse(data.content);
      return content.dpIp;
    },
    portFormat(grids, data) {
      const content = JSON.parse(data.content);
      return content.dpPort;
    },
    productFormat(grids, data) {
      const content = JSON.parse(data.content);
      if (content.product === 0) {
        return '3000';
      }
      if (content.product === 1) {
        return '6000';
      }
      if (content.product === 2) {
        return '3000';
      }
      return '3000';
    },
    deploymentNormFormat(grids, data) {
      const content = JSON.parse(data.content);
      if (content.deploymentNorm === 0) {
        return '单机单点';
      }
      if (content.deploymentNorm === 1) {
        return '单机集群';
      }
      if (content.deploymentNorm === 2) {
        return '单主多从最小规格';
      }
      if (content.deploymentNorm === 3) {
        return '单主多从中等规格';
      }
      if (content.deploymentNorm === 4) {
        return '单主多从大型规格';
      }
      if (content.deploymentNorm === 5) {
        return '双主多从最小规格';
      }
      if (content.deploymentNorm === 6) {
        return '双主多从中等规格';
      }
      if (content.deploymentNorm === 7) {
        return '双主多从大型规格';
      }
      if (content.deploymentNorm === 8) {
        return '自定义';
      }
      return '自定义';
    },
    addDPEnviroment(node) {
      this.$refs.addDPEnviromentPage.show();
    },
    getCheckedVals(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const dpIds = [];
      const checkedData = this.getCheckedData(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        dpIds.push(checkedData[i].dpId);
      }
      return dpIds.length === 0 ? false : dpIds;
    },
    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Topo.pleaseSelect') });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('Topo.pleaseSelectOne') });
        return false;
      }
      return selectedRecords;
    },
    getDeployTemplate() {
      const checkedData = this.getCheckedData(false);
      if (checkedData) {
        this.$refs.oneKeyDeploymentPage.show();
        this.$refs.oneKeyDeploymentDialog.getTemplateContent(checkedData[0]);
      }
    },
    oneKeyDeployment() {
      const params = this.$refs.oneKeyDeploymentDialog.getData();
      this.$axios.post('/lte/ems/nf/deploy.html', params).then((response) => {
        this.closeOneKeyDeploymentPage();
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            this.getGridData();
            EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
          } else {
            EventBus.$emit('toast', { type: 'warning', content: '部署失败' });
          }
        }
      });
    },
    getDeployInstance() {
      this.$refs.deployedInstancePage.show();
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.qryParam.environmentId = selectedRecords[0].id;
      this.$refs.deployedInstanceDialog.init(2);
    },
    delDPEnviroment(node) {
      const dpIdVec = this.getCheckedVals(true);
      console.log('dpIdVec', dpIdVec)
      if (dpIdVec) {
        // let params = JSON.stringify(dpIdVec[0]);
        this.$layer.confirm({
          msg: this.$t('Topo.sureDel'),
          btn1: {
            msg: this.$t('Topo.cancel')
          },
          btn2: {
            msg: this.$t('Topo.confirm'),
            func: this.delDp
          }
        });
      }
    },
    delDp() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      const params = selectedRecords[0].id;
      console.log('selectedRecords', selectedRecords)
      this.axios.get(`/lte/ems/env/delEnvironment.html?id=${params}`).then((response) => {
        if (response.data === undefined) {
          return;
        }
        if (response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            this.getGridData();
            EventBus.$emit('toast', { type: 'success', content: this.$t('Topo.delSuccess') });
          } else {
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
          }
        }
      });
    },
    closeDPEnviromentPage() {
      this.$refs.addDPEnviromentPage.close();
    },
    getGridData() {
      const $this = this;
      this.$axios.post('/lte/ems/env/getEnvironmentList.html', {
        type: 'DP',
        page: {
          pageNo: $this.page.pageNo,
          pageSize: $this.page.pageSize
        }
      }).then((response) => {
        const res = response.data.resultVal;
        if (response.status === 200 && res !== null) {
          $this.data = res.result;
          $this.page.totalCount = res.countrsp;
          // EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
        } else {
          EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
        }
      });
    },
    getDetailUEData() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('UE.ueSelectDatas') });
        return false;
      }
      if (selectedRecords.length > 1) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('UE.ueSelectOneData') });
        return false;
      }
      return true;
    },
    getChooseCount() {
    }
  },
  mounted() {
    this.getGridData();
  }
};
</script>

<style scoped>

</style>
